import styled from "styled-components";

const FIELD_FONT = `
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.45;
  color: #1e293b;
`;

export const Container = styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px;
  ${FIELD_FONT}
`;

export const Header = styled.div`
  margin-bottom: 8px;
`;

export const ModeButton = styled.button<{ active: boolean }>`
  margin-right: 8px;
  font-family: inherit;
  font-size: 13px;
  font-weight: ${({ active }) => (active ? 600 : 500)};
  color: ${({ active }) => (active ? "#0f172a" : "#64748b")};
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px 4px;

  &:hover {
    color: #0f172a;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 200px;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background: #fff;
  resize: vertical;
  appearance: none;
  -webkit-appearance: none;
  box-shadow: none;
  outline: none;
  ${FIELD_FONT}

  &:focus {
    border-color: #94a3b8;
  }
`;

export const Preview = styled.div`
  background: #fafafa;
  padding: 12px;
  border-radius: 6px;
  min-height: 200px;
  ${FIELD_FONT}

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  li,
  blockquote,
  pre,
  code {
    font-family: inherit;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.45;
    color: #1e293b;
  }

  h1,
  h2,
  h3 {
    font-weight: 600;
    margin-bottom: 8px;
  }

  p {
    margin-bottom: 10px;
  }

  strong {
    font-weight: 600;
  }

  em {
    font-style: italic;
  }

  ul,
  ol {
    padding-left: 20px;
    margin-bottom: 10px;
  }

  ul {
    list-style: disc;
  }

  ol {
    list-style: decimal;
  }
`;
